import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
  useCallback,
} from 'react';
import {
  getMe as getMeApi,
  login as loginApi,
  register as registerApi,
  logout as logoutApi,
} from '../services/authApi';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshMe = async () => {
    try {
      const me = await getMeApi();
      setUser(me);
      return me;
    } catch (e) {
      setUser(null);
      return null;
    }
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      await refreshMe();
      setLoading(false);
    })();
  }, []);

  const login = useCallback(async (payload) => {
    await loginApi(payload);
    return refreshMe();
  }, []);

  const register = useCallback(async (payload) => {
    await registerApi(payload);
    return refreshMe();
  }, []);

  const logout = useCallback(async () => {
    await logoutApi();
    setUser(null);
  }, []);

  const value = useMemo(
    () => ({ user, loading, login, register, logout, refreshMe }),
    [user, loading, login, register, logout]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
